import { render } from "./TopButtons.vue?vue&type=template&id=0243b658&scoped=true"
import script from "./TopButtons.vue?vue&type=script&lang=js"
export * from "./TopButtons.vue?vue&type=script&lang=js"

import "./TopButtons.vue?vue&type=style&index=0&id=0243b658&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0243b658"]])

export default __exports__